import { defineComponent } from 'vue'
import type { ExtractPropTypes } from 'vue'


export const pagetableColumnIndexProps = () => ({})

export type PagetableColumnIndexProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnIndexProps>>>

export default defineComponent({
  name: 'OPagetableColumnIndex',
  inheritAttrs: false,
  props: pagetableColumnIndexProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
